/* eslint-disable no-unused-vars */
import { AccountVariationsConfig } from '@nizza/core';
import React, { Fragment, useEffect, useState } from 'react';
import type {
  PlayerProduct,
  PlayerVariationSelector,
  PlayerVariationValues,
} from '../../../types';
import { getElementById, querySelectorAll } from '../../../utils';
import { isColor } from '../utils';
import styles from './styles.module.css';

type SizeVariationsProps = {
  product: PlayerProduct;
  setSelectedSize: React.Dispatch<
    React.SetStateAction<PlayerVariationValues[]>
  >;
  selectedSize: PlayerVariationValues[];
  roundOrSquareSelector?: 'round-selector' | 'square-selector';
  variationsConfig?: AccountVariationsConfig;
};

export const SizeVariations = ({
  product,
  setSelectedSize,
  selectedSize,
  roundOrSquareSelector,
  variationsConfig,
}: SizeVariationsProps) => {
  const nameSelectedVariations = variationsConfig?.selected?.map(x =>
    x.toLowerCase(),
  );
  const nameOmittedVariations = variationsConfig?.omitted?.map(x =>
    x.toLowerCase(),
  );
  const [filteredVariation, setFilteredVariation] = useState<
    PlayerVariationSelector[]
  >([]);

  useEffect(() => {
    if (product?.variationSelector.length <= 0) return;

    const uniqueVariations = new Set();

    const otherVariations = product?.variationSelector?.filter(item => {
      const name = item.field.name;

      if (!uniqueVariations.has(name)) {
        uniqueVariations.add(name);

        if (nameSelectedVariations?.length) {
          return (
            !isColor(item.field.name) &&
            nameSelectedVariations.includes(item.field.name.toLowerCase())
          );
        } else if (nameOmittedVariations?.length) {
          return (
            !isColor(item.field.name) &&
            !nameOmittedVariations.includes(item.field.name.toLowerCase())
          );
        } else {
          return !isColor(item.field.name);
        }
      }

      return [];
    }) as PlayerVariationSelector[];

    if (otherVariations.length) {
      setFilteredVariation(otherVariations);

      const selectVariation = otherVariations.map(variation => {
        return {
          id: variation.values[0].id,
          name: variation.values[0].name,
          variationId: variation.field.id,
          variationName: variation.field.name,
          image: variation.values[0]?.image,
        };
      });

      if (selectedSize.length === 0) setSelectedSize(selectVariation as any[]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product?.variationSelector]);

  const handleSizeSelect = (
    sizeId: string,
    value: PlayerVariationValues,
    variation: number | string,
    variationName: string,
  ) => {
    const selectItem = selectedSize.filter(
      select => select.variationId !== variation,
    );
    value.variationId = Number(variation);
    value.variationName = variationName;

    selectItem.push(value);
    setSelectedSize(selectItem);

    const divSelect = getElementById(sizeId);
    const divSelects = querySelectorAll(`.divSelectColor-${variation}`);

    divSelects.forEach(item => {
      if ((item as HTMLElement).style.display === 'initial') {
        item.removeAttribute('style');
        item.setAttribute('style', 'display: none');
      }
    });

    if (divSelect) divSelect.style.display = 'initial';
  };

  return (
    <div className={styles.variationContent}>
      {filteredVariation?.length > 0 &&
        filteredVariation.map(variation => (
          <Fragment key={variation.field.id}>
            <h2 className={styles.titleVariation}>{variation.field.name}:</h2>
            <div className={styles.itemContent}>
              {variation.values.map(value => (
                <div
                  key={value.id}
                  className={`${styles.itemSize} ${roundOrSquareSelector === 'round-selector' &&
                    styles.roundSelector
                    }`}
                >
                  <div
                    id={value.id}
                    className={`${styles.itemSizeSelect} divSelectColor-${variation.field.id
                      } ${roundOrSquareSelector === 'round-selector' &&
                      styles.roundSelector
                      }`}
                    style={
                      selectedSize.length > 0
                        ? selectedSize.find(
                          select => select.name === value.name,
                        )
                          ? { display: 'initial' }
                          : { display: 'none' }
                        : { display: 'none' }
                    }
                  />
                  <div
                    className={styles.itemSizeBackground}
                    onClick={() =>
                      handleSizeSelect(
                        value.id,
                        value,
                        variation.field.id,
                        variation.field.name,
                      )
                    }
                  >
                    <span>{value.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </Fragment>
        ))}
    </div>
  );
};
